const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = theme => ({
  textFieldL: {
    marginRight: theme.spacing.unit * 2,
    display: "block",
    minWidth: minWidth / 2
  },
  textFieldR: {
    marginRight: theme.spacing.unit * 2,
    width: 500
  },
  targetHeading: {
    display: "flex",
    justifyContent: "space-between"
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    position: "absolute",
    right: 150,
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  modalHeader: {
    fontWeight: "700!important",
    fontSize: "1.4rem!important"
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    float: "right",
    marginTop: 15,
    right: 150,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }

  },
  mainBody: {
    maxWidth: 700,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto"
  },
  lengthText: {
    fontWeight: "bold",
    paddingBottom: 20
  }
});

export default styles;
